import React from "react";
import { Link } from "react-router-dom";

const InvestDetail = ({ imageUrl, description, price, length, location }) => {
  return (
    <>
      <div className="flex flex-row my-10">
        <div className="w-1/2">
          <img src="/dhul.jpg" className="w-full h-auto rounded-md " />
        </div>
        <div className="ml-10 w-1/2">
          <div className="flex flex-col mb-3">
            <div className="flex items-center flex-row ">
              <div>
                <img src="/es.png" className="w-6 h-6 mr-2" />
              </div>
              <div className="text-2xl font-semibold">Description</div>
            </div>
            <p className="text-md text-gray-500 ">
              A land description with fertilization and water means the land has
              been enriched with nutrients to promote plant growth and has a
              reliable source of water for irrigation. Fertilization involves
              adding essential nutrients to the soil, such as nitrogen,
              phosphorus, and potassium, to improve its fertility and support
              healthy plant growth.
            </p>
          </div>
          <div className="flex flex-row items-center  mb-3">
            <div className="flex items-center flex-row ">
              <div>
                <img src="/loc.png" className="w-6 h-6 mr-2" />
              </div>
              <div className="text-2xl font-semibold">Location:</div>
            </div>
            <p className="text-lg text-gray-500 ml-3 ">Hargeisa</p>
          </div>
          <div className="flex flex-row items-center  mb-3">
            <div className="flex items-center flex-row ">
              <div>
                <img src="/price.png" className="w-6 h-6 mr-2" />
              </div>
              <div className="text-2xl font-semibold">Price:</div>
            </div>
            <p className="text-lg text-gray-500  ml-3">$2500</p>
          </div>
          <div className="flex flex-row items-center  mb-3">
            <div className="flex items-center flex-row ">
              <div>
                <img src="/length.png" className="w-7 h-7 mr-2" />
              </div>
              <div className="text-2xl font-semibold">Length:</div>
            </div>
            <p className="text-lg text-gray-500 ml-3">50 Squar</p>
          </div>
          <Link to="/register">
            <div className="bg-[#f0f974] px-4 py-3 rounded-md mt-10  font-semibold w-40 mx-52">
              Register To Invest
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default InvestDetail;
